/* oxlint-disable typescript/no-explicit-any */
import { clsx } from 'clsx';
import * as styles from '../styles.css';

export const customizedGroupTick = (props: any) => {
  const { index, x, y, payload } = props;

  return (
    <g>
      <g>
        {index !== 0 && (
          <circle
            fill="#7683A0"
            cx={x}
            cy={y + 4}
            r={3}
            stroke="#7683A0"
            className={clsx(styles['pin'], styles['custom-pin'])}
          />
        )}
        <text
          orientation="bottom"
          width="490"
          height="30"
          stroke="none"
          x={x}
          y={y + 5}
          textAnchor="middle"
          fill="#666"
        >
          <tspan x={x} dy="20px">
            {payload.value}
          </tspan>
        </text>
      </g>
    </g>
  );
};
